import { useQuery } from '@tanstack/react-query';
import { queryClient, QUERY_KEYS } from '@src/query';
import { getUserConfig } from './api';
import { useAuthEnabled } from '@src/hooks/useAuthStatus';

/**
 * Get config
 */
export const useQueryUserConfig = () => {
  const authEnabled = useAuthEnabled();

  return useQuery({
    queryKey: QUERY_KEYS.userConfig(),
    queryFn: getUserConfig,
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: authEnabled,
  });
};

export function prefetchQueryUserConfig() {
  return queryClient.prefetchQuery({ queryKey: QUERY_KEYS.userConfig(), queryFn: getUserConfig });
}
